import { render, staticRenderFns } from "./servicerRegularList.vue?vue&type=template&id=5466bf7a&scoped=true"
import script from "./servicerRegularList.vue?vue&type=script&lang=js"
export * from "./servicerRegularList.vue?vue&type=script&lang=js"
import style0 from "./servicerRegularList.vue?vue&type=style&index=0&id=5466bf7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466bf7a",
  null
  
)

export default component.exports